import { FormContainer as Container, InputField as Input, FormSection as Section } from "../../components";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import { useNavigate } from "react-router-dom";
import { validateStep } from "../../utils/pageValidator.js";

function SwisAgreementInfo() {
    const { injectFormProps } = useInjectFormProps();
    const navigate = useNavigate();

    const beforeSubmit = () => {
        if (!validateStep()) {
            return;
        }
        navigate("/main-form");
    }

    return (
        <Container>
            {injectFormProps(
                <>
                    <p style={{ fontSize: "1.8rem", fontWeight: "500" }}>Agreement to Share Information:</p>
                    <hr />
                    <Section>
                        <p>Documents collected may include:</p>
                        <ul>
                            <li>Identification papers
                            </li>
                            <li>Residency status documents of children and parents
                            </li>
                            <li>Study permits
                            </li>
                            <li>Work permits
                            </li>
                            <li>Visas</li>
                            <li>School registration forms
                            </li>
                            <li>Student assessment information
                            </li>
                            <li>Any other documents of me or my children that they might need to help my children start school.
                            </li>
                        </ul>
                        <Input type="checkbox" inputLabel={"I agree that the Good SpiritSchool Division and the East Central Newcomer Welcome Centre can collect and share information."} identifier={"isShareDocAgreed"}></Input>
                        <Input type="checkbox" inputLabel={"I agree that the East Central Newcomer Welcome Centre and Good SpiritSchool Division can share with each other any information and documents I give them."} identifier={"isShareInfoAgreed"}></Input>
                        <Input type="checkbox" inputLabel={"I agree to share this information so that the East Central Newcomer Welcome Centre and Good SpiritSchool Division can work together to help my children transition into school."} identifier={"isSwisGssdWorkTogetherAgreed"}></Input>
                        <Input type="text" inputLabel={"Name of Registrant"} identifier={"registrantName"}></Input>
                    </Section>
                    <hr></hr>
                    <button type="button" onClick={beforeSubmit} className={"default-btn justify-center"}>Continue</button>
                </>
            )}
        </Container>
    );
}

export default SwisAgreementInfo;